import React, { Fragment } from 'react';
import ErrorLogView from './ErrorLogView';

const ErrorLog = () => {
    return (
        <Fragment>
            <ErrorLogView />
        </Fragment>
    );
};

export default ErrorLog;
